var React = require('react');

function Tags (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"currentColor","fillRule":"nonzero","stroke":"currentColor"},[React.createElement("path",{"strokeWidth":"1.2","d":"M9.546 16c.463 0 .89-.178 1.21-.499l4.737-4.739a1.7 1.7 0 0 0 0-2.422L9.154 1.998C8.584 1.428 7.552 1 6.77 1h-4.06C1.783 1 1 1.784 1 2.71v4.062c0 .784.427 1.817.997 2.387l6.338 6.342c.32.32.748.499 1.211.499zM6.727 2.036c.505 0 1.3.324 1.66.684l6.424 6.405a.629.629 0 0 1 0 .9l-4.8 4.786c-.252.252-.686.252-.902 0L2.686 8.406C2.325 8.046 2 7.29 2 6.75V2.648c0-.36.289-.648.65-.648h4.077v.036z","key":0}),React.createElement("path",{"strokeWidth":".5","d":"M6 7.7c1.085 0 2-.881 2-2 0-1.085-.881-2-2-2-1.085 0-2 .881-2 2 0 1.085.881 2 2 2zm0-3.05c.576 0 1.05.474 1.05 1.05 0 .576-.474 1.05-1.05 1.05-.576 0-1.05-.474-1.05-1.05 0-.576.474-1.05 1.05-1.05z","key":1})]));
}

Tags.defaultProps = {"viewBox":"0 0 17 17"};

module.exports = Tags;

Tags.default = Tags;
